import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ErrorCodeModule } from '@portal-core/errors/components/error-code/error-code.module';
import { ErrorCodeExpansionPanelComponent } from './error-code-expansion-panel.component';

@NgModule({
  declarations: [
    ErrorCodeExpansionPanelComponent
  ],
  imports: [
    CommonModule,
    ErrorCodeModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule
  ],
  exports: [
    ErrorCodeExpansionPanelComponent
  ]
})
export class ErrorCodeExpansionPanelModule { }
